import env from "@gtmhub/env/module";
import { BetaFeaturesService } from ".";
import { FeatureToggleService } from "./feature-toggle-service";
import { FeatureToggle } from "./directives/feature-toggle";
import { IRootScopeService } from "angular";
import { AccountResolverService } from "@gtmhub/state/accountResolverService";

const mod = angular.module("featureToggles", [env]);
// LaunchDarkly feature toggle
mod.service("FeatureToggleService", FeatureToggleService);
mod.service("BetaFeaturesService", BetaFeaturesService);
mod.directive("featureToggleEnabled", FeatureToggle.factory());
mod.directive("featureToggleDisabled", FeatureToggle.factory());

mod.run([
  "$rootScope",
  "FeatureToggleService",
  "AccountResolverService",
  function ($rootScope: IRootScopeService, featureToggleService: FeatureToggleService, accountResolverService: AccountResolverService) {
    const account = accountResolverService.getAccountData();
    if (account) {
      featureToggleService.initialize();
    } else {
      $rootScope.$on("accountCreated", () => {
        featureToggleService.initialize();
      });

      $rootScope.$on("authorizationProcessed", () => {
        featureToggleService.initialize();
      });

      $rootScope.$on("accountDataInitialized", () => {
        featureToggleService.initialize();
      });
    }
  },
]);

export default mod.name;
